<div class="modal-header">
  <h4 class="modal-title">Commentaires</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Autheur</th>
        <th scope="col">Type</th>
        <th scope="col">Commentaire</th>
        <th *ngIf="user.isStaff || user.isSupervisor || user.isCorrector" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <!-- Du plus récent au plus ancien : le dernier commentaire est le plus consulté -->
      <tr *ngFor="let comment of exam.reverseChronologicalComments; index as i">
        <td>{{comment.created_date | date:'dd/MM/yyyy HH:mm'}}</td>
        <td>{{comment.author}}</td>
        <td>
          <span class="badge" [ngClass]="categoryByKey(comment.category).badgeClass">
            {{categoryByKey(comment.category).label}}
          </span>
        </td>
        <td>
          <div *ngIf="editedComment && editedComment.id == comment.id">
            <form [formGroup]="editCommentForm">
              <!-- Sélecteur de catégorie -->
              <label for="editCommentCategory">Catégorie</label>
              <div id="editCommentCategory" class="btn-group btn-group-sm mb-2 d-block" role="group">
                <button type="button" class="btn"
                  *ngFor="let cat of categories"
                  [ngClass]="editCommentForm.get('category').value === cat.key ? cat.buttonClass : 'btn-outline-secondary'"
                  (click)="selectCategory(editCommentForm, cat.key)">
                  {{cat.label}}
                </button>
              </div>
              <!-- Phrases types du niveau sélectionné, à la couleur de l'onglet -->
              <div class="mb-2">
                <button type="button" class="btn btn-sm rounded-pill mr-1 mb-1 phrase-chip"
                  [ngClass]="categoryByKey(editCommentForm.get('category').value).chipClass"
                  *ngFor="let phrase of phrasesFor(editCommentForm.get('category').value)"
                  (click)="applyPhrase(editCommentForm, phrase)">
                  {{phrase}}
                </button>
              </div>
              <input type="text" class="form-control" formControlName='comment' placeholder="Editer le commentaire">
            </form>
          </div>
          <div *ngIf="!editedComment || editedComment.id != comment.id">
            {{comment.comment}}
          </div>
        </td>
        <td *ngIf="user.isStaff || user.isSupervisor || user.isCorrector">
          <button *ngIf="!editedComment || editedComment.id != comment.id" class="btn btn-link"
            (click)="editComment(comment)" [disabled]="deletedComment != null && deletedComment.id == comment.id">
            <i class="fas fa-edit"></i>
          </button>
          <button *ngIf="editedComment && editedComment.id == comment.id" class="btn btn-link"
            (click)="submitEditedComment()" [disabled]="editCommentForm.invalid || submittingEditedComment">
            <span *ngIf="submittingEditedComment" class="button-loader"></span>
            <i *ngIf="!submittingEditedComment" class="fas fa-check"></i>
          </button>
          <button *ngIf="!editedComment || editedComment.id != comment.id" class="btn btn-link"
            (click)="deleteComment(comment)" [disabled]="deletedComment != null && deletedComment.id == comment.id">
            <span *ngIf="deletedComment != null && deletedComment.id == comment.id" class="button-loader"></span>
            <i *ngIf="deletedComment == null || deletedComment.id != comment.id" class="fas fa-trash"></i>
          </button>
          <button *ngIf="editedComment && editedComment.id == comment.id" class="btn btn-link"
            (click)="cancelEditComment()" [disabled]="submittingEditedComment">
            <i class="fas fa-times"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- Zone de saisie, séparée de la liste des commentaires ci-dessus -->
  <div *ngIf="user.isStaff || user.isSupervisor || user.isCorrector" class="bg-light border rounded p-3 mt-4">
    <h5>Nouveau commentaire</h5>
    <form [formGroup]="form">
      <!-- Sélecteur de catégorie -->
      <label for="newCommentCategory">Catégorie</label>
      <div id="newCommentCategory" class="btn-group btn-group-sm mb-2 d-block" role="group">
        <button type="button" class="btn"
          *ngFor="let cat of categories"
          [ngClass]="form.get('category').value === cat.key ? cat.buttonClass : 'btn-outline-secondary'"
          (click)="selectCategory(form, cat.key)">
          {{cat.label}}
        </button>
      </div>
      <!-- Phrases types du niveau sélectionné, à la couleur de l'onglet -->
      <div class="mb-2">
        <button type="button" class="btn btn-sm rounded-pill mr-1 mb-1 phrase-chip"
          [ngClass]="categoryByKey(form.get('category').value).chipClass"
          *ngFor="let phrase of phrasesFor(form.get('category').value)"
          (click)="applyPhrase(form, phrase)">
          {{phrase}}
        </button>
      </div>
      <div style="display: flex;">
        <textarea class="form-control" id="comment" formControlName='comment' placeholder="Message"
          style="margin-right: 10px;"></textarea>
        <button type="button" class="btn btn-outline-secondary" [disabled]="form.invalid || submittingComment"
          (click)="submitComment()">
          <span *ngIf="submittingComment" class="button-loader"></span>
          Commenter
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="error" class="alert alert-danger">
    {{error}}
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">Fermer</button>
</div>
